// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimatedCheck_container__xUjQK"};